import { render, staticRenderFns } from "./CancelTransfer.vue?vue&type=template&id=10b7d1c3&scoped=true"
import script from "./CancelTransfer.vue?vue&type=script&lang=js"
export * from "./CancelTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b7d1c3",
  null
  
)

export default component.exports